// Dashboard and Start My Day. Expanded in Phase 1 task 1.2 (dashboard rebuild).

export const dashboardCopy = {
  // Next-action hero card
  nextActionHeader: 'Next',
  startFocusBlock: 'Start focus block',
  startPreparingMeeting: 'Start meeting prep',
  startWorkItem: 'Start next work item',

  // Priorities section
  prioritiesHeader: 'Today',
  priorityUnaligned: 'Not linked to a driver',

  // Risk strip
  risksHeader: 'Needs attention',
  risksEmpty: 'Nothing flagged. Plan is on track.',

  // Capacity strip
  capacityCommitted: 'committed',
  capacityProtected: 'protected',
  capacitySlack: 'free',
} as const;
